import React from "react";
import { Map as MapLib } from "maplibre-gl";
// @ts-expect-error unfortunately missing types it appears
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import ReactDOM from "react-dom/client";
import { proxy } from "valtio";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import { EditMeasureIcon } from "../../../common/components/icons";

export interface DrawControlsState {
  drawControlsOpen: boolean;
}

export class DrawControlsStateManager {
  public state: DrawControlsState = proxy({
    drawControlsOpen: false,
  });

  public draw: MapboxDraw;

  constructor() {
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        point: false,
        line_string: false,
        polygon: false,
        trash: false,
        combine_features: false,
        uncombine_features: false,
      },
    });
  }

  public addDrawControls(map: MapLib) {
    map.addControl(this.draw);

    // HACKY af way to add the measure control button to the map. But okay for now
    const element = document.createElement("div");
    const controlBox = document.getElementsByClassName("maplibregl-ctrl");
    controlBox[0].appendChild(element);

    const bearingButton = document.getElementsByClassName(
      "maplibregl-ctrl-compass",
    );
    (bearingButton.item(0) as HTMLButtonElement).style.setProperty(
      "border-bottom",
      "1px solid rgb(221, 221, 221)",
    );

    ReactDOM.createRoot(element).render(
      <button
        className="measure-control-button"
        onClick={() => {
          this.state.drawControlsOpen = !this.state.drawControlsOpen;
        }}
      >
        <EditMeasureIcon style={{ color: "black" }} />
      </button>,
    );
  }
}
